export default __webpack_public_path__ + "static/media/15_photo.a1e3f90e.jpg";